import callback from 'app/entities/callback/callback.reducer';
import catalogoInstitucion from 'app/entities/catalogo-institucion/catalogo-institucion.reducer';
import cliente from 'app/entities/cliente/cliente.reducer';
import estatus from 'app/entities/estatus/estatus.reducer';
import mensaje from 'app/entities/mensaje/mensaje.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  cliente,
  mensaje,
  callback,
  catalogoInstitucion,
  estatus,
  // jhipster-needle-add-reducer-combine - JHipster will add reducer here
};

export default entitiesReducers;
